const config = {
  storageToken: '@kopalive:token'
};

export default config;